import uuid from "uuid/v4"

const assignIds = (components) => {
  return components.map((c) => {
    let id = uuid()
    return {
      id,
      ...c,
      components: c.components && assignIds(c.components),
    }
  })
}

const removeIds = (components) => {
  return components.map(({ id, components: children, ...c }) => {
    let obj = c

    if (children) {
      obj.components = removeIds(children)
    }

    return obj
  })
}

const updateComponent = (components, id, updates) => {
  let list = Array.from(components)
  let i = list.findIndex((c) => c.id === id)

  if (i > -1) {
    list[i] = {
      ...list[i],
      ...updates,
    }

    return list
  }

  return list.map((c) => {
    if (!c.components) return c

    return {
      ...c,
      components: updateComponent(c.components, id, updates),
    }
  })
}

const deleteComponent = (components, id) => {
  let list = Array.from(components)
  let i = list.findIndex((c) => c.id === id)

  if (i > -1) {
    list.splice(i, 1)

    return list
  }
  return list.map((c) => {
    if (!c.components) return c
    return {
      ...c,
      components: deleteComponent(c.components, id),
    }
  })
}

const moveComponent = (components, id, direction) => {
  let list = Array.from(components)
  let i = list.findIndex((c) => c.id === id)

  if (i > -1) {
    let toIndex = i + direction
    let [removed] = list.splice(i, 1)

    list.splice(toIndex, 0, removed)

    return list
  }
  return list.map((c) => {
    if (!c.components) return c
    return {
      ...c,
      components: moveComponent(c.components, id, direction),
    }
  })
}

const addComponent = (components, id, newComponent) => {
  let list = Array.from(components)

  if (!id) {
    list.push(newComponent)
    return list
  }

  let i = list.findIndex((c) => c.id === id)

  if (i > -1) {
    list[i].components.push(newComponent)

    return list
  }

  return list.map((c) => {
    if (!c.components) return c
    return {
      ...c,
      components: addComponent(c.components, id, newComponent),
    }
  })
}

export {
  assignIds,
  removeIds,
  updateComponent,
  deleteComponent,
  addComponent,
  moveComponent,
}
